// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"636":"6a48755c8d7fa49c","2323":"c41373013ea7b655","5756":"cdf3dda4139e0e20","9342":"05dca7da28efb61a"}[chunkId] + ".css";
};